import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../src/core/api/axiosClient";

const initialState: any = {
  testReports: [],
  filter: {},
  isLoadingTestReports: false,
  emergencyLightByBlockCode: [],
  isLoadingEmergencyLightByBlockCode: false,
  isLoading: false,
  error: null,

  testReportsDownload: [],
  isLoadingTestReportsDownload: false,
};

export const getTestReports: any = createAsyncThunk(
  "content/getTestReports",
  async ({
    PageNumber,
    pageSize,
    tcCode = null,
    siteCode = null,
    blockCode = null,
    emergencyLight = null,
    startDate = null,
    endDate = null,
    SortBy,
    SortDirection,
  }: any) => {
    const payload = {
      PageNumber,
      pageSize,
      tcCode,
      siteCode,
      blockCode,
      emergencyLight,
      startDate,
      endDate,
      SortBy,
      SortDirection,
    };
    const res = await axios.post(`/slpapp/Report/getTestReport`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const downLoadTestReportsFile: any = createAsyncThunk(
  "content/downLoadTestReportsFile",
  async ({
    fileType = "downloadPdf",
    tcCode = null,
    siteCode = null,
    blockCode = null,
    emergencyLight = null,
    startDate = null,
    endDate = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      emergencyLight,
      startDate,
      endDate,
    };

    try {
      const response = await axios.post(
        `/slpapp/Report/getTestReport/${fileType}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      let fileBlob;
      if (fileType === "downloadPdf") {
        fileBlob = new Blob([response.data], { type: "application/pdf" });
      } else {
        fileBlob = new Blob([response.data], {
          type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      // if (fileType == "downloadPdf") {
      //   link.download = filename;
      // } else {
      //   link.download = filename;
      // }
      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading test report:", error);
      throw error;
    }
  }
);

export const getEmergencyLightByBlockCode: any = createAsyncThunk(
  "content/getEmergencyLightByBlockCode",
  async ({ blockCode }: any) => {
    const res = await axios.get(`/slpapp/Asset/getEmergencyLights`, {
      params: { blockCode },
    });

    const data = await res?.data;
    return data;
  }
);

export const testReportSlice = createSlice({
  name: "testReport",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTestReports.pending, (state) => {
      state.isLoadingTestReports = true;
    });
    builder.addCase(getTestReports.fulfilled, (state, action) => {
      state.isLoadingTestReports = false;
      state.testReports = action.payload;
    });
    builder.addCase(getTestReports.rejected, (state, action) => {
      state.isLoadingTestReports = false;
      state.error = action.error.message;
    });

    builder.addCase(getEmergencyLightByBlockCode.pending, (state) => {
      state.isLoadingEmergencyLightByBlockCode = true;
    });
    builder.addCase(getEmergencyLightByBlockCode.fulfilled, (state, action) => {
      state.isLoadingEmergencyLightByBlockCode = false;
      state.emergencyLightByBlockCode = action.payload;
    });
    builder.addCase(getEmergencyLightByBlockCode.rejected, (state, action) => {
      state.isLoadingEmergencyLightByBlockCode = false;
      state.error = action.error.message;
    });

    builder.addCase(downLoadTestReportsFile.pending, (state) => {
      state.isLoadingTestReportsDownload = true;
    });
    builder.addCase(downLoadTestReportsFile.fulfilled, (state, action) => {
      state.isLoadingTestReportsDownload = false;
      state.testReportsDownload = action.payload;
    });
    builder.addCase(downLoadTestReportsFile.rejected, (state, action) => {
      state.isLoadingTestReportsDownload = false;
      state.error = action.error.message;
    });
  },
});

export const { setFilter } = testReportSlice.actions;

export default testReportSlice.reducer;
